const addVerCenter =  (userId) => ({
    api: `/api/v2/systemManagers/${userId}/verificationCenters`
})
 const  addMedCenter = (userId, verCenterId) => ({
api: `/api/v2/systemManagers/${userId}/verificationCenters/${verCenterId}/medCenters`, method: "POST"
})
 const addOrganizationByMedId = (userId, verCenterId, medId, ) =>  ({
    api: `/api/v2/systemManagers/${userId}/verificationCenters/${verCenterId}/medCenters/${medId}/organizations`, method: "POST"
})
const addOrganization = (userId, verCenterId ) =>  ({
    api: `/api/v2/systemManagers/${userId}/verificationCenters/${verCenterId}/organizations`, method: "POST"
})

 export const API_counterparties = {
    addingOrganization: {
        addMedCenter,
        addOrganizationByMedId,
        addVerCenter,
        addOrganization
}
 }